module.exports = __webpack_public_path__ + "img/prize-04.a357b7ce.png";